// src/pages/MS/MSU002F1.jsx
import React from 'react';



const MSR101F1 = () => {

    return(
        <main >
            MSR101F1
        </main>
    )
}
export default MSR101F1;
